import { BitcoinPaymentsStatusResult } from '@square/dashboard-protos/models/squareup/cls/fields/bitcoin/bitcoin_payments_status';
import { FulfillmentMethods } from '@square/dashboard-protos/models/squareup/fulfillment/behaviors/client/fulfillment_methods_client';
import { AutoGratuitySettings, MenuBehaviorSettings, ReceiptSettings, SalesAttributionSettings, ReopenSettings, CourseSettings, PreAuthSettings, CloseOfDayReportSettings, EmployeeShiftReportSettings, ReservationSettings } from '@square/dashboard-protos/models/squareup/rstonboard/service_settings/service_settings';
const anyTypeRegistry = {
  'type.googleapis.com/squareup.cls.fields.bitcoin.BitcoinPaymentsStatusResult': BitcoinPaymentsStatusResult,
  'type.googleapis.com/squareup.fulfillment.behaviors.config.FulfillmentMethods': FulfillmentMethods,
  'type.googleapis.com/squareup.rstonboard.MenuBehaviorSettings': MenuBehaviorSettings,
  'type.googleapis.com/squareup.rstonboard.AutoGratuitySettings': AutoGratuitySettings,
  'type.googleapis.com/squareup.rstonboard.ReceiptSettings': ReceiptSettings,
  'type.googleapis.com/squareup.rstonboard.SalesAttributionSettings': SalesAttributionSettings,
  'type.googleapis.com/squareup.rstonboard.ReopenSettings': ReopenSettings,
  'type.googleapis.com/squareup.rstonboard.CourseSettings': CourseSettings,
  'type.googleapis.com/squareup.rstonboard.PreAuthSettings': PreAuthSettings,
  'type.googleapis.com/squareup.rstonboard.CloseOfDayReportSettings': CloseOfDayReportSettings,
  'type.googleapis.com/squareup.rstonboard.EmployeeShiftReportSettings': EmployeeShiftReportSettings,
  'type.googleapis.com/squareup.rstonboard.ReservationSettings': ReservationSettings
};
const ANY_ENDPOINTS = new Set(['squareup.cls.api.ExternalClientLogicService#Evaluate', 'squareup.settingshub.api.ExternalSettingsHubService#WriteSettings', 'squareup.settingshub.api.ExternalSettingsHubService#ReadSettings', 'squareup.settingshub.api.ExternalSettingsHubService#DeleteSettings']);
export function isAnyEndpoint(service, method) {
  return ANY_ENDPOINTS.has(`${service}#${method}`);
}
const MAX_DEPTH = 20;
export function typeNameFromTypeUrl(typeUrl) {
  const slashIndex = typeUrl.lastIndexOf('/');
  if (slashIndex === -1) {
    return null;
  }
  return typeUrl.slice(slashIndex + 1) || null;
}
function isAnyLike(obj) {
  return typeof obj['typeUrl'] === 'string' && 'value' in obj;
}
function isProtobufMessage(obj) {
  return typeof obj['toJSON'] === 'function' && '$type' in obj;
}
function walk(input, seen, depth) {
  if (depth > MAX_DEPTH) {
    return input;
  }
  if (Array.isArray(input)) {
    return input.map(item => walk(item, seen, depth + 1));
  }
  if (input === null || typeof input !== 'object') {
    return input;
  }
  const obj = input;
  if (seen.has(obj)) {
    return obj;
  }
  seen.add(obj);
  if (isProtobufMessage(obj)) {
    const type = obj['$type'];
    const plainObj = type.toObject(obj, {
      enums: String,
      bytes: Uint8Array
    });
    return walkPlain(plainObj, seen, depth);
  }
  return walkPlain(obj, seen, depth);
}
function walkPlain(obj, seen, depth) {
  if (isAnyLike(obj)) {
    const outAny = {
      ...obj
    };
    if (obj.value instanceof Uint8Array) {
      const decoder = anyTypeRegistry[obj.typeUrl];
      if (decoder) {
        try {
          const decoded = decoder.decode(obj.value);
          outAny.decodedValue = walk(decoded, seen, depth + 1);
        } catch (e) {
          outAny.decodedValue = {
            $error: `Decode failed: ${e instanceof Error ? e.message : String(e)}`
          };
        }
      } else {
        outAny.decodedValue = {
          $error: `No decoder registered for ${obj.typeUrl}`
        };
      }
    }
    return outAny;
  }
  const result = {};
  for (const key of Object.keys(obj)) {
    result[key] = walk(obj[key], seen, depth + 1);
  }
  return result;
}
export function decodeAnyRecursively(input) {
  try {
    return walk(input, new WeakSet(), 0);
  } catch {
    return input;
  }
}